import * as Types from '../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type NonPharmaSkuResolveQueryVariables = Types.Exact<{
  facilityId: Types.Scalars['String'];
  locationId?: Types.InputMaybe<Types.Scalars['String']>;
  nonPharmaItemId: Types.Scalars['String'];
}>;


export type NonPharmaSkuResolveQuery = { readonly __typename?: 'Query', readonly inventorySearchTmp: { readonly __typename?: 'InventorySummaryConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'InventorySummaryEdge', readonly node: { readonly __typename?: 'InventorySummary', readonly id: string, readonly quantity?: number | null, readonly supplyLevel?: Types.SupplyLevel | null, readonly sku: { readonly __typename?: 'Sku', readonly id: string } } }> } };

export type NonPharmaLotsQueryVariables = Types.Exact<{
  skuId: Types.Scalars['String'];
  facilityId: Types.Scalars['String'];
  locationId?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type NonPharmaLotsQuery = { readonly __typename?: 'Query', readonly getLotsBySkuId: ReadonlyArray<{ readonly __typename?: 'Lot', readonly id: string, readonly locationId?: string | null, readonly quantity: number, readonly expiryDate: string }> };

export type DispenseStockMutationVariables = Types.Exact<{
  input: ReadonlyArray<Types.DispenseStockInput> | Types.DispenseStockInput;
}>;


export type DispenseStockMutation = { readonly __typename?: 'Mutation', readonly dispenseStock: ReadonlyArray<{ readonly __typename?: 'Lot', readonly id: string, readonly quantity: number, readonly expiryDate: string }> };


export const NonPharmaSkuResolveDocument = gql`
    query nonPharmaSkuResolve($facilityId: String!, $locationId: String, $nonPharmaItemId: String!) {
  inventorySearchTmp(
    input: {facilityId: $facilityId, locationId: $locationId, active: true, externalReferences: [{origin: "non_pharma", foreignId: $nonPharmaItemId}]}
    options: {pageSize: 1}
  ) {
    edges {
      node {
        id
        quantity
        supplyLevel
        sku {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useNonPharmaSkuResolveQuery__
 *
 * To run a query within a React component, call `useNonPharmaSkuResolveQuery` and pass it any options that fit your needs.
 * When your component renders, `useNonPharmaSkuResolveQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNonPharmaSkuResolveQuery({
 *   variables: {
 *      facilityId: // value for 'facilityId'
 *      locationId: // value for 'locationId'
 *      nonPharmaItemId: // value for 'nonPharmaItemId'
 *   },
 * });
 */
export function useNonPharmaSkuResolveQuery(baseOptions: Apollo.QueryHookOptions<NonPharmaSkuResolveQuery, NonPharmaSkuResolveQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NonPharmaSkuResolveQuery, NonPharmaSkuResolveQueryVariables>(NonPharmaSkuResolveDocument, options);
      }
export function useNonPharmaSkuResolveLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NonPharmaSkuResolveQuery, NonPharmaSkuResolveQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NonPharmaSkuResolveQuery, NonPharmaSkuResolveQueryVariables>(NonPharmaSkuResolveDocument, options);
        }
export type NonPharmaSkuResolveQueryHookResult = ReturnType<typeof useNonPharmaSkuResolveQuery>;
export type NonPharmaSkuResolveLazyQueryHookResult = ReturnType<typeof useNonPharmaSkuResolveLazyQuery>;
export type NonPharmaSkuResolveQueryResult = Apollo.QueryResult<NonPharmaSkuResolveQuery, NonPharmaSkuResolveQueryVariables>;
export const NonPharmaLotsDocument = gql`
    query nonPharmaLots($skuId: String!, $facilityId: String!, $locationId: String) {
  getLotsBySkuId(
    input: {skuId: $skuId, facilityId: $facilityId, locationId: $locationId}
  ) {
    id
    locationId
    quantity
    expiryDate
  }
}
    `;

/**
 * __useNonPharmaLotsQuery__
 *
 * To run a query within a React component, call `useNonPharmaLotsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNonPharmaLotsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNonPharmaLotsQuery({
 *   variables: {
 *      skuId: // value for 'skuId'
 *      facilityId: // value for 'facilityId'
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useNonPharmaLotsQuery(baseOptions: Apollo.QueryHookOptions<NonPharmaLotsQuery, NonPharmaLotsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NonPharmaLotsQuery, NonPharmaLotsQueryVariables>(NonPharmaLotsDocument, options);
      }
export function useNonPharmaLotsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NonPharmaLotsQuery, NonPharmaLotsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NonPharmaLotsQuery, NonPharmaLotsQueryVariables>(NonPharmaLotsDocument, options);
        }
export type NonPharmaLotsQueryHookResult = ReturnType<typeof useNonPharmaLotsQuery>;
export type NonPharmaLotsLazyQueryHookResult = ReturnType<typeof useNonPharmaLotsLazyQuery>;
export type NonPharmaLotsQueryResult = Apollo.QueryResult<NonPharmaLotsQuery, NonPharmaLotsQueryVariables>;
export const DispenseStockDocument = gql`
    mutation dispenseStock($input: [DispenseStockInput!]!) {
  dispenseStock(input: $input) {
    id
    quantity
    expiryDate
  }
}
    `;
export type DispenseStockMutationFn = Apollo.MutationFunction<DispenseStockMutation, DispenseStockMutationVariables>;

/**
 * __useDispenseStockMutation__
 *
 * To run a mutation, you first call `useDispenseStockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDispenseStockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dispenseStockMutation, { data, loading, error }] = useDispenseStockMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDispenseStockMutation(baseOptions?: Apollo.MutationHookOptions<DispenseStockMutation, DispenseStockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DispenseStockMutation, DispenseStockMutationVariables>(DispenseStockDocument, options);
      }
export type DispenseStockMutationHookResult = ReturnType<typeof useDispenseStockMutation>;
export type DispenseStockMutationResult = Apollo.MutationResult<DispenseStockMutation>;
export type DispenseStockMutationOptions = Apollo.BaseMutationOptions<DispenseStockMutation, DispenseStockMutationVariables>;